module.exports = __webpack_public_path__ + "static/media/backup.fd267260.svg";